// Capacity (34_Capacity.jsx, CapacityMonths.jsx) — the screen's strings in the portal's four languages (2026-10-21).
// Vendor codes, cycles, seasons, months (Jan…Dec, the portal's date style) and the typed values the hints suggest
// ("Normal / Pull FW", "Pass / Fail" — the workbook's own words) stay as written.
const en = {
  loadFailed: 'Load failed ({{status}})',
  saveFailed: 'Save failed ({{status}})',
  title: 'Capacity',
  introLines: "PO lines and the hours behind them. Cycle times come from the SCT summary for the line's own season.",
  introMonths: 'The hours these orders need, against the hours the vendor has. The hours available are typed in — nothing else holds them.',
  tabLines: 'Lines',
  tabMonths: 'Load vs capacity',
  statLines: 'Lines',
  stillOpen: '{{n}} still open',
  statQuantity: 'Quantity',
  pcs: 'pcs',
  statOrderHours: 'Order hours',
  statHoursDone: 'Hours done',
  statHoursRemaining: 'Hours remaining',
  allVendors: 'All vendors',
  allCycles: 'All cycles',
  allLines: 'All lines',
  openOnly: 'Open only',
  finished: 'Finished',
  searchPh: 'Item#, description, PO, colour…',
  clear: 'Clear',
  columns: 'Columns',
  nHidden: '· {{n}} hidden',
  showColumns: 'Show columns',
  showAll: 'Show all',
  pinNote: 'pin = freeze every column up to here',
  unfreeze: 'Unfreeze',
  freezeThrough: 'Freeze through this column',
  hiddenNoFreeze: 'Hidden columns cannot be frozen',
  loading: 'Loading…',
  reload: 'Reload',
  hiddenTyped_one: '{{count}} typed column is hidden, so it cannot be typed into.',
  hiddenTyped_other: '{{count}} typed columns are hidden, so they cannot be typed into.',
  showThem: 'Show them',
  colAction: 'Action',
  saveEnter: 'Save (Enter)',
  cancelEsc: 'Cancel (Esc)',
  editRowTitle: 'Type the hand-filled fields in the row',
  noLines: 'No PO lines match these filters.',
  // where a cycle time / the row's identity columns come from (also the funnel values)
  srcTyped: 'typed',
  fsMaster: 'Master Sheet',
  fsAmbiguous: 'file · ambiguous',
  fsFileOnly: 'file only',
  fsMasterShort: 'Master',
  fsFileShort: 'file',
  fsWorkbookSays: 'The workbook says: {{diff}}',
  fsReadFromMaster: 'Read from the Master Sheet row this line points at',
  fsManyDisagree: 'Several Master Sheet rows match and they disagree — no honest pick',
  fsNoMaster: 'No Master Sheet row for this line; the workbook is the only source',
  // the delivery-date tree
  allDeliveryDates: 'All delivery dates',
  noMonths: 'No months',
  monthsOf: '{{n}} of {{total}} months',
  deliveryDate: 'Delivery date',
  selectAll: '(Select All)',
  collapse: 'Collapse',
  expand: 'Expand',
  col: {
    source: 'Source',
    vendor: 'Vendor',
    season: 'Season',
    vendorPo: 'Vendor PO',
    cycle: 'Cycle',
    customerPo: 'Customer PO',
    destination: 'Destination',
    item: 'Item#',
    description: 'Description',
    colour: 'Colour',
    qty: 'Qty',
    delivery: 'Delivery',
    skinCt: 'Skin CT',
    caseCt: 'Case CT',
    ctFrom: 'CT from',
    skinOut: 'Skin out',
    caseOut: 'Case out',
    orderH: 'Order h',
    doneH: 'Done h',
    remainH: 'Remain h',
    mark: 'Mark',
    fiDate: 'FI date',
    result: 'Result',
    ship: 'Ship',
    remark: 'Remark',
    newExfty: 'New ex-fty',
  },
  // Load vs capacity (CapacityMonths)
  cm: {
    workers: 'Workers',
    hoursPerDay: 'Hours/day',
    workDays: 'Work days',
    efficiency: 'Efficiency %',
    overrideHours: 'Override hours',
    note: 'Note',
    hintPeople: 'people',
    hintEg8: 'e.g. 8',
    hintInMonth: 'in the month',
    hintAsIs: '100 = as is',
    hintInsteadFormula: 'instead of the formula',
    hoursNeeded: 'Hours needed',
    hoursNeededSub: 'still to make, in these months',
    hoursAvailable: 'Hours available',
    notAnswered_one: '{{count}} month not answered yet',
    notAnswered_other: '{{count}} months not answered yet',
    allAnswered: 'every month answered',
    none: 'None',
    monthsOver: 'Months over capacity',
    monthsOverSub: 'more hours ordered than there are',
    fromThisMonth: 'From this month',
    allMonths: 'All months',
    colMonth: 'Month',
    colVendor: 'Vendor',
    colLines: 'Lines',
    colQty: 'Qty',
    colHoursNeeded: 'Hours needed',
    colAvailable: 'Available',
    colLoad: 'Load',
    colOverBy: 'Over by',
    overrideTitle: 'Override. The formula gives {{n}}',
    notSetTitle: 'Nobody has said what this vendor has this month',
    notSet: 'not set',
    ovrShort: '·ovr',
    editMonthTitle: "Type this vendor's hours for this month",
    noMonths: 'No months match these filters.',
  },
};

const ko = {
  loadFailed: '불러오기 실패 ({{status}})',
  saveFailed: '저장 실패 ({{status}})',
  title: '생산 능력',
  introLines: 'PO 라인과 그에 필요한 시간입니다. 사이클 타임은 해당 라인 시즌의 SCT 요약에서 가져옵니다.',
  introMonths: '이 오더들에 필요한 시간과 벤더가 가진 시간을 비교합니다. 가용 시간은 직접 입력합니다 — 다른 곳에는 이 값이 없습니다.',
  tabLines: 'PO 라인',
  tabMonths: '부하 vs 생산 능력',
  statLines: '라인',
  stillOpen: '{{n}}개 진행 중',
  statQuantity: '수량',
  pcs: 'pcs',
  statOrderHours: '오더 시간',
  statHoursDone: '완료 시간',
  statHoursRemaining: '남은 시간',
  allVendors: '전체 벤더',
  allCycles: '전체 사이클',
  allLines: '전체 라인',
  openOnly: '진행 중만',
  finished: '완료',
  searchPh: 'Item#, 품명, PO, 색상…',
  clear: '초기화',
  columns: '열 선택',
  nHidden: '· {{n}}개 숨김',
  showColumns: '표시할 열',
  showAll: '모두 표시',
  pinNote: '핀 = 이 열까지 모두 고정',
  unfreeze: '고정 해제',
  freezeThrough: '이 열까지 고정',
  hiddenNoFreeze: '숨긴 열은 고정할 수 없습니다',
  loading: '불러오는 중…',
  reload: '새로고침',
  hiddenTyped_one: '직접 입력하는 열 {{count}}개가 숨겨져 있어 입력할 수 없습니다.',
  hiddenTyped_other: '직접 입력하는 열 {{count}}개가 숨겨져 있어 입력할 수 없습니다.',
  showThem: '표시하기',
  colAction: '작업',
  saveEnter: '저장 (Enter)',
  cancelEsc: '취소 (Esc)',
  editRowTitle: '이 행에서 직접 입력하는 항목 입력',
  noLines: '이 필터에 맞는 PO 라인이 없습니다.',
  srcTyped: '직접 입력',
  fsMaster: 'Master Sheet',
  fsAmbiguous: '파일 · 불명확',
  fsFileOnly: '파일만',
  fsMasterShort: 'Master',
  fsFileShort: '파일',
  fsWorkbookSays: '워크북 값: {{diff}}',
  fsReadFromMaster: '이 라인이 가리키는 Master Sheet 행에서 읽음',
  fsManyDisagree: '여러 Master Sheet 행이 일치하지만 서로 달라 하나를 고를 수 없음',
  fsNoMaster: '이 라인에 해당하는 Master Sheet 행이 없어 워크북이 유일한 출처임',
  allDeliveryDates: '전체 납기일',
  noMonths: '선택된 월 없음',
  monthsOf: '{{total}}개월 중 {{n}}개월',
  deliveryDate: '납기일',
  selectAll: '(전체 선택)',
  collapse: '접기',
  expand: '펼치기',
  col: {
    source: '출처',
    vendor: '벤더',
    season: '시즌',
    vendorPo: '벤더 PO',
    cycle: '사이클',
    customerPo: '고객 PO',
    destination: '도착지',
    item: 'Item#',
    description: '품명',
    colour: '색상',
    qty: '수량',
    delivery: '납기',
    skinCt: 'Skin CT',
    caseCt: 'Case CT',
    ctFrom: 'CT 출처',
    skinOut: 'Skin 생산',
    caseOut: 'Case 생산',
    orderH: '오더 h',
    doneH: '완료 h',
    remainH: '잔여 h',
    mark: '구분',
    fiDate: 'FI 날짜',
    result: '결과',
    ship: '선적 방식',
    remark: '비고',
    newExfty: '새 ex-fty',
  },
  cm: {
    workers: '작업자',
    hoursPerDay: '시간/일',
    workDays: '근무일',
    efficiency: '효율 %',
    overrideHours: '수동 시간',
    note: '메모',
    hintPeople: '명',
    hintEg8: '예: 8',
    hintInMonth: '해당 월',
    hintAsIs: '100 = 그대로',
    hintInsteadFormula: '공식 대신',
    hoursNeeded: '필요 시간',
    hoursNeededSub: '이 기간에 아직 생산해야 할 시간',
    hoursAvailable: '가용 시간',
    notAnswered_one: '미입력 월 {{count}}개',
    notAnswered_other: '미입력 월 {{count}}개',
    allAnswered: '모든 월 입력됨',
    none: '없음',
    monthsOver: '생산 능력 초과 월',
    monthsOverSub: '가용 시간보다 오더 시간이 많음',
    fromThisMonth: '이번 달부터',
    allMonths: '전체 월',
    colMonth: '월',
    colVendor: '벤더',
    colLines: '라인',
    colQty: '수량',
    colHoursNeeded: '필요 시간',
    colAvailable: '가용',
    colLoad: '부하',
    colOverBy: '초과',
    overrideTitle: '수동 입력값. 공식 계산값은 {{n}}',
    notSetTitle: '이 벤더의 이번 달 가용 시간을 아직 아무도 입력하지 않았습니다',
    notSet: '미입력',
    ovrShort: '·수동',
    editMonthTitle: '이 벤더의 이번 달 시간 입력',
    noMonths: '이 필터에 맞는 월이 없습니다.',
  },
};

const vi = {
  loadFailed: 'Tải thất bại ({{status}})',
  saveFailed: 'Lưu thất bại ({{status}})',
  title: 'Năng lực sản xuất',
  introLines: 'Các dòng PO và số giờ cần cho chúng. Cycle time lấy từ bảng tổng hợp SCT theo đúng mùa của dòng.',
  introMonths: 'Số giờ các đơn hàng này cần, so với số giờ nhà cung cấp có. Số giờ khả dụng được nhập tay — không nơi nào khác lưu số này.',
  tabLines: 'Dòng PO',
  tabMonths: 'Tải so với năng lực',
  statLines: 'Số dòng',
  stillOpen: '{{n}} dòng đang mở',
  statQuantity: 'Số lượng',
  pcs: 'pcs',
  statOrderHours: 'Giờ theo đơn',
  statHoursDone: 'Giờ đã làm',
  statHoursRemaining: 'Giờ còn lại',
  allVendors: 'Tất cả nhà cung cấp',
  allCycles: 'Tất cả chu kỳ',
  allLines: 'Tất cả dòng',
  openOnly: 'Chỉ dòng đang mở',
  finished: 'Đã xong',
  searchPh: 'Item#, mô tả, PO, màu…',
  clear: 'Xóa lọc',
  columns: 'Cột',
  nHidden: '· {{n}} cột ẩn',
  showColumns: 'Hiện cột',
  showAll: 'Hiện tất cả',
  pinNote: 'ghim = cố định mọi cột đến cột này',
  unfreeze: 'Bỏ cố định',
  freezeThrough: 'Cố định đến cột này',
  hiddenNoFreeze: 'Không thể cố định cột đang ẩn',
  loading: 'Đang tải…',
  reload: 'Tải lại',
  hiddenTyped_one: '{{count}} cột nhập tay đang ẩn nên không thể nhập.',
  hiddenTyped_other: '{{count}} cột nhập tay đang ẩn nên không thể nhập.',
  showThem: 'Hiện các cột đó',
  colAction: 'Thao tác',
  saveEnter: 'Lưu (Enter)',
  cancelEsc: 'Hủy (Esc)',
  editRowTitle: 'Nhập các trường điền tay ngay trên dòng',
  noLines: 'Không có dòng PO nào khớp bộ lọc.',
  srcTyped: 'nhập tay',
  fsMaster: 'Master Sheet',
  fsAmbiguous: 'file · không rõ',
  fsFileOnly: 'chỉ có file',
  fsMasterShort: 'Master',
  fsFileShort: 'file',
  fsWorkbookSays: 'Workbook ghi: {{diff}}',
  fsReadFromMaster: 'Đọc từ dòng Master Sheet mà dòng này trỏ tới',
  fsManyDisagree: 'Nhiều dòng Master Sheet khớp nhưng khác nhau — không thể chọn chắc chắn',
  fsNoMaster: 'Không có dòng Master Sheet cho dòng này; workbook là nguồn duy nhất',
  allDeliveryDates: 'Tất cả ngày giao',
  noMonths: 'Không chọn tháng nào',
  monthsOf: '{{n}} / {{total}} tháng',
  deliveryDate: 'Ngày giao hàng',
  selectAll: '(Chọn tất cả)',
  collapse: 'Thu gọn',
  expand: 'Mở rộng',
  col: {
    source: 'Nguồn',
    vendor: 'Nhà cung cấp',
    season: 'Mùa',
    vendorPo: 'PO nhà cung cấp',
    cycle: 'Chu kỳ',
    customerPo: 'PO khách hàng',
    destination: 'Điểm đến',
    item: 'Item#',
    description: 'Mô tả',
    colour: 'Màu',
    qty: 'SL',
    delivery: 'Ngày giao',
    skinCt: 'Skin CT',
    caseCt: 'Case CT',
    ctFrom: 'Nguồn CT',
    skinOut: 'Skin đã làm',
    caseOut: 'Case đã làm',
    orderH: 'Giờ đơn',
    doneH: 'Giờ đã làm',
    remainH: 'Giờ còn lại',
    mark: 'Đánh dấu',
    fiDate: 'Ngày FI',
    result: 'Kết quả',
    ship: 'Vận chuyển',
    remark: 'Ghi chú',
    newExfty: 'Ex-fty mới',
  },
  cm: {
    workers: 'Công nhân',
    hoursPerDay: 'Giờ/ngày',
    workDays: 'Ngày làm',
    efficiency: 'Hiệu suất %',
    overrideHours: 'Giờ ghi đè',
    note: 'Ghi chú',
    hintPeople: 'người',
    hintEg8: 'VD: 8',
    hintInMonth: 'trong tháng',
    hintAsIs: '100 = giữ nguyên',
    hintInsteadFormula: 'thay cho công thức',
    hoursNeeded: 'Giờ cần',
    hoursNeededSub: 'còn phải làm, trong các tháng này',
    hoursAvailable: 'Giờ khả dụng',
    notAnswered_one: '{{count}} tháng chưa nhập',
    notAnswered_other: '{{count}} tháng chưa nhập',
    allAnswered: 'đã nhập đủ mọi tháng',
    none: 'Không có',
    monthsOver: 'Tháng vượt năng lực',
    monthsOverSub: 'giờ đặt hàng nhiều hơn giờ hiện có',
    fromThisMonth: 'Từ tháng này',
    allMonths: 'Tất cả các tháng',
    colMonth: 'Tháng',
    colVendor: 'Nhà cung cấp',
    colLines: 'Số dòng',
    colQty: 'SL',
    colHoursNeeded: 'Giờ cần',
    colAvailable: 'Khả dụng',
    colLoad: 'Tải',
    colOverBy: 'Vượt',
    overrideTitle: 'Ghi đè. Công thức cho ra {{n}}',
    notSetTitle: 'Chưa ai nhập số giờ nhà cung cấp này có trong tháng này',
    notSet: 'chưa nhập',
    ovrShort: '·ghi đè',
    editMonthTitle: 'Nhập số giờ của nhà cung cấp này cho tháng này',
    noMonths: 'Không có tháng nào khớp bộ lọc.',
  },
};

const zh = {
  loadFailed: '加载失败（{{status}}）',
  saveFailed: '保存失败（{{status}}）',
  title: '产能',
  introLines: 'PO 行及其所需工时。周期时间取自该行所属季的 SCT 汇总。',
  introMonths: '这些订单所需工时与供应商可用工时的对比。可用工时为手动录入 — 其他地方没有这些数据。',
  tabLines: 'PO 行',
  tabMonths: '负荷与产能',
  statLines: '行数',
  stillOpen: '{{n}} 行未完成',
  statQuantity: '数量',
  pcs: '件',
  statOrderHours: '订单工时',
  statHoursDone: '已完成工时',
  statHoursRemaining: '剩余工时',
  allVendors: '全部供应商',
  allCycles: '全部周期',
  allLines: '全部行',
  openOnly: '仅未完成',
  finished: '已完成',
  searchPh: 'Item#、品名、PO、颜色…',
  clear: '清除',
  columns: '列',
  nHidden: '· 隐藏 {{n}} 列',
  showColumns: '显示列',
  showAll: '全部显示',
  pinNote: '图钉 = 冻结到此列为止的所有列',
  unfreeze: '取消冻结',
  freezeThrough: '冻结到此列',
  hiddenNoFreeze: '隐藏的列无法冻结',
  loading: '加载中…',
  reload: '重新加载',
  hiddenTyped_one: '{{count}} 个手填列已隐藏，因此无法录入。',
  hiddenTyped_other: '{{count}} 个手填列已隐藏，因此无法录入。',
  showThem: '显示这些列',
  colAction: '操作',
  saveEnter: '保存（Enter）',
  cancelEsc: '取消（Esc）',
  editRowTitle: '在行内填写手填字段',
  noLines: '没有符合这些筛选条件的 PO 行。',
  srcTyped: '手填',
  fsMaster: 'Master Sheet',
  fsAmbiguous: '文件 · 不明确',
  fsFileOnly: '仅文件',
  fsMasterShort: 'Master',
  fsFileShort: '文件',
  fsWorkbookSays: '工作簿中为：{{diff}}',
  fsReadFromMaster: '读取自该行所指向的 Master Sheet 行',
  fsManyDisagree: '有多个 Master Sheet 行匹配且彼此不一致 — 无法可靠选择',
  fsNoMaster: '该行没有对应的 Master Sheet 行；工作簿是唯一来源',
  allDeliveryDates: '全部交货日期',
  noMonths: '未选月份',
  monthsOf: '{{n}} / {{total}} 个月',
  deliveryDate: '交货日期',
  selectAll: '（全选）',
  collapse: '收起',
  expand: '展开',
  col: {
    source: '来源',
    vendor: '供应商',
    season: '季',
    vendorPo: '供应商 PO',
    cycle: '周期',
    customerPo: '客户 PO',
    destination: '目的地',
    item: 'Item#',
    description: '品名',
    colour: '颜色',
    qty: '数量',
    delivery: '交货',
    skinCt: 'Skin CT',
    caseCt: 'Case CT',
    ctFrom: 'CT 来源',
    skinOut: 'Skin 产出',
    caseOut: 'Case 产出',
    orderH: '订单工时',
    doneH: '已完成工时',
    remainH: '剩余工时',
    mark: '标记',
    fiDate: 'FI 日期',
    result: '结果',
    ship: '运输',
    remark: '备注',
    newExfty: '新 ex-fty',
  },
  cm: {
    workers: '工人',
    hoursPerDay: '小时/天',
    workDays: '工作日',
    efficiency: '效率 %',
    overrideHours: '覆盖工时',
    note: '备注',
    hintPeople: '人',
    hintEg8: '例如 8',
    hintInMonth: '当月',
    hintAsIs: '100 = 原样',
    hintInsteadFormula: '代替公式',
    hoursNeeded: '所需工时',
    hoursNeededSub: '这些月份仍需生产',
    hoursAvailable: '可用工时',
    notAnswered_one: '{{count}} 个月尚未填写',
    notAnswered_other: '{{count}} 个月尚未填写',
    allAnswered: '所有月份均已填写',
    none: '无',
    monthsOver: '超出产能的月份',
    monthsOverSub: '订单工时多于可用工时',
    fromThisMonth: '从本月起',
    allMonths: '全部月份',
    colMonth: '月份',
    colVendor: '供应商',
    colLines: '行数',
    colQty: '数量',
    colHoursNeeded: '所需工时',
    colAvailable: '可用',
    colLoad: '负荷',
    colOverBy: '超出',
    overrideTitle: '手动覆盖。公式结果为 {{n}}',
    notSetTitle: '尚无人填写该供应商本月的可用工时',
    notSet: '未设置',
    ovrShort: '·覆盖',
    editMonthTitle: '填写该供应商本月的工时',
    noMonths: '没有符合这些筛选条件的月份。',
  },
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "loadFailed": "Échec du chargement ({{status}})",
  "saveFailed": "Échec de l'enregistrement ({{status}})",
  "title": "Capacité",
  "introLines": "Lignes de PO et heures correspondantes. Les temps de cycle proviennent du résumé SCT de la saison propre à la ligne.",
  "introMonths": "Les heures nécessaires à ces commandes, par rapport aux heures dont dispose le fournisseur. Les heures disponibles sont saisies à la main — aucune autre source ne les détient.",
  "tabLines": "Lignes",
  "tabMonths": "Charge vs capacité",
  "statLines": "Lignes",
  "stillOpen": "{{n}} encore ouvertes",
  "statQuantity": "Quantité",
  "pcs": "pcs",
  "statOrderHours": "Heures commandées",
  "statHoursDone": "Heures réalisées",
  "statHoursRemaining": "Heures restantes",
  "allVendors": "Tous les fournisseurs",
  "allCycles": "Tous les cycles",
  "allLines": "Toutes les lignes",
  "openOnly": "Ouvertes uniquement",
  "finished": "Terminées",
  "searchPh": "Item#, description, PO, couleur…",
  "clear": "Effacer",
  "columns": "Colonnes",
  "nHidden": "· {{n}} masquée(s)",
  "showColumns": "Afficher les colonnes",
  "showAll": "Tout afficher",
  "pinNote": "épingle = figer toutes les colonnes jusqu'ici",
  "unfreeze": "Libérer",
  "freezeThrough": "Figer jusqu'à cette colonne",
  "hiddenNoFreeze": "Les colonnes masquées ne peuvent pas être figées",
  "loading": "Chargement…",
  "reload": "Recharger",
  "hiddenTyped_one": "{{count}} colonne de saisie est masquée ; elle ne peut donc pas être renseignée.",
  "hiddenTyped_other": "{{count}} colonnes de saisie sont masquées ; elles ne peuvent donc pas être renseignées.",
  "showThem": "Les afficher",
  "colAction": "Action",
  "saveEnter": "Enregistrer (Entrée)",
  "cancelEsc": "Annuler (Échap)",
  "editRowTitle": "Saisir les champs à remplir à la main dans la ligne",
  "noLines": "Aucune ligne de PO ne correspond à ces filtres.",
  "srcTyped": "saisi",
  "fsMaster": "Master Sheet",
  "fsAmbiguous": "fichier · ambigu",
  "fsFileOnly": "fichier uniquement",
  "fsMasterShort": "Master",
  "fsFileShort": "fichier",
  "fsWorkbookSays": "Le classeur indique : {{diff}}",
  "fsReadFromMaster": "Lu depuis la ligne du Master Sheet vers laquelle pointe cette ligne",
  "fsManyDisagree": "Plusieurs lignes du Master Sheet correspondent et se contredisent — aucun choix fiable",
  "fsNoMaster": "Aucune ligne du Master Sheet pour cette ligne ; le classeur est la seule source",
  "allDeliveryDates": "Toutes les dates de livraison",
  "noMonths": "Aucun mois",
  "monthsOf": "{{n}} mois sur {{total}}",
  "deliveryDate": "Date de livraison",
  "selectAll": "(Tout sélectionner)",
  "collapse": "Réduire",
  "expand": "Développer",
  "col": {
    "source": "Source",
    "vendor": "Fournisseur",
    "season": "Saison",
    "vendorPo": "PO fournisseur",
    "cycle": "Cycle",
    "customerPo": "PO client",
    "destination": "Destination",
    "item": "Item#",
    "description": "Description",
    "colour": "Couleur",
    "qty": "Qté",
    "delivery": "Livraison",
    "skinCt": "Skin CT",
    "caseCt": "Case CT",
    "ctFrom": "CT depuis",
    "skinOut": "Skin sortie",
    "caseOut": "Case sortie",
    "orderH": "H commandées",
    "doneH": "H réalisées",
    "remainH": "H restantes",
    "mark": "Repère",
    "fiDate": "Date FI",
    "result": "Résultat",
    "ship": "Expédition",
    "remark": "Remarque",
    "newExfty": "Nouveau ex-fty"
  },
  "cm": {
    "workers": "Effectif",
    "hoursPerDay": "Heures/jour",
    "workDays": "Jours ouvrés",
    "efficiency": "Efficacité %",
    "overrideHours": "Heures forcées",
    "note": "Remarque",
    "hintPeople": "personnes",
    "hintEg8": "ex. 8",
    "hintInMonth": "dans le mois",
    "hintAsIs": "100 = tel quel",
    "hintInsteadFormula": "à la place de la formule",
    "hoursNeeded": "Heures nécessaires",
    "hoursNeededSub": "restant à produire, sur ces mois",
    "hoursAvailable": "Heures disponibles",
    "notAnswered_one": "{{count}} mois sans réponse pour l'instant",
    "notAnswered_other": "{{count}} mois sans réponse pour l'instant",
    "allAnswered": "tous les mois sont renseignés",
    "none": "Aucun",
    "monthsOver": "Mois en dépassement de capacité",
    "monthsOverSub": "plus d'heures commandées que disponibles",
    "fromThisMonth": "À partir de ce mois",
    "allMonths": "Tous les mois",
    "colMonth": "Mois",
    "colVendor": "Fournisseur",
    "colLines": "Lignes",
    "colQty": "Qté",
    "colHoursNeeded": "Heures nécessaires",
    "colAvailable": "Disponibles",
    "colLoad": "Charge",
    "colOverBy": "Dépassement",
    "overrideTitle": "Valeur forcée. La formule donne {{n}}",
    "notSetTitle": "Personne n'a indiqué la capacité de ce fournisseur pour ce mois",
    "notSet": "non défini",
    "ovrShort": "·forcé",
    "editMonthTitle": "Saisir les heures de ce fournisseur pour ce mois",
    "noMonths": "Aucun mois ne correspond à ces filtres."
  }
};
const ja = {
  "loadFailed": "読み込みに失敗しました（{{status}}）",
  "saveFailed": "保存に失敗しました（{{status}}）",
  "title": "キャパシティ",
  "introLines": "PO 明細とその裏付けとなる工数です。サイクルタイムは、明細自身のシーズンの SCT サマリーから取得します。",
  "introMonths": "これらの注文に必要な工数と、工場が確保している工数の比較です。確保工数は手入力で、他に保持している場所はありません。",
  "tabLines": "明細",
  "tabMonths": "負荷とキャパシティ",
  "statLines": "明細",
  "stillOpen": "{{n}} 件が未完了",
  "statQuantity": "数量",
  "pcs": "pcs",
  "statOrderHours": "注文工数",
  "statHoursDone": "完了工数",
  "statHoursRemaining": "残り工数",
  "allVendors": "すべての工場",
  "allCycles": "すべてのサイクル",
  "allLines": "すべての明細",
  "openOnly": "未完了のみ",
  "finished": "完了",
  "searchPh": "Item#、説明、PO、カラー…",
  "clear": "クリア",
  "columns": "列",
  "nHidden": "· {{n}} 列を非表示",
  "showColumns": "列を表示",
  "showAll": "すべて表示",
  "pinNote": "ピン = ここまでのすべての列を固定",
  "unfreeze": "固定を解除",
  "freezeThrough": "この列まで固定",
  "hiddenNoFreeze": "非表示の列は固定できません",
  "loading": "読み込み中…",
  "reload": "再読み込み",
  "hiddenTyped_one": "入力列 {{count}} 列が非表示のため、入力できません。",
  "hiddenTyped_other": "入力列 {{count}} 列が非表示のため、入力できません。",
  "showThem": "表示する",
  "colAction": "操作",
  "saveEnter": "保存（Enter）",
  "cancelEsc": "キャンセル（Esc）",
  "editRowTitle": "行の手入力項目を入力",
  "noLines": "これらのフィルターに一致する PO 明細はありません。",
  "srcTyped": "入力値",
  "fsMaster": "Master Sheet",
  "fsAmbiguous": "ファイル · 判別不能",
  "fsFileOnly": "ファイルのみ",
  "fsMasterShort": "Master",
  "fsFileShort": "ファイル",
  "fsWorkbookSays": "ワークブックの内容：{{diff}}",
  "fsReadFromMaster": "この明細が指している Master Sheet の行から読み取りました",
  "fsManyDisagree": "複数の Master Sheet の行が一致し、内容も食い違っています — 確実に選べません",
  "fsNoMaster": "この明細に対応する Master Sheet の行がありません。ワークブックが唯一の情報源です",
  "allDeliveryDates": "すべての納期",
  "noMonths": "月がありません",
  "monthsOf": "{{total}} か月中 {{n}} か月",
  "deliveryDate": "納期",
  "selectAll": "（すべて選択）",
  "collapse": "折りたたむ",
  "expand": "展開",
  "col": {
    "source": "ソース",
    "vendor": "仕入先",
    "season": "シーズン",
    "vendorPo": "仕入先 PO",
    "cycle": "サイクル",
    "customerPo": "顧客PO",
    "destination": "仕向地",
    "item": "Item#",
    "description": "説明",
    "colour": "カラー",
    "qty": "数量",
    "delivery": "納期",
    "skinCt": "Skin CT",
    "caseCt": "Case CT",
    "ctFrom": "CT の出所",
    "skinOut": "Skin 出来高",
    "caseOut": "Case 出来高",
    "orderH": "注文 h",
    "doneH": "完了 h",
    "remainH": "残り h",
    "mark": "マーク",
    "fiDate": "FI 日",
    "result": "結果",
    "ship": "出荷",
    "remark": "備考",
    "newExfty": "新 ex-fty"
  },
  "cm": {
    "workers": "作業者数",
    "hoursPerDay": "時間/日",
    "workDays": "稼働日数",
    "efficiency": "効率 %",
    "overrideHours": "上書き工数",
    "note": "備考",
    "hintPeople": "人",
    "hintEg8": "例：8",
    "hintInMonth": "当月の",
    "hintAsIs": "100 = そのまま",
    "hintInsteadFormula": "計算式の代わりに",
    "hoursNeeded": "必要工数",
    "hoursNeededSub": "これらの月でこれから生産する分",
    "hoursAvailable": "確保工数",
    "notAnswered_one": "{{count}} か月が未回答",
    "notAnswered_other": "{{count}} か月が未回答",
    "allAnswered": "すべての月に回答済み",
    "none": "なし",
    "monthsOver": "キャパシティ超過の月",
    "monthsOverSub": "確保工数を超える工数が注文されています",
    "fromThisMonth": "今月から",
    "allMonths": "すべての月",
    "colMonth": "月",
    "colVendor": "仕入先",
    "colLines": "明細",
    "colQty": "数量",
    "colHoursNeeded": "必要工数",
    "colAvailable": "確保",
    "colLoad": "負荷",
    "colOverBy": "超過分",
    "overrideTitle": "上書き。計算式の結果は {{n}} です",
    "notSetTitle": "この月の仕入先の確保工数は、誰も入力していません",
    "notSet": "未設定",
    "ovrShort": "·上書き",
    "editMonthTitle": "この月のこの仕入先の工数を入力",
    "noMonths": "これらのフィルターに一致する月はありません。"
  }
};

const dictionary = { ns: 'xCapacity', en, ko, vi, zh, fr, ja };

export default dictionary;
